import { connect } from "react-redux";
import JainSymbol from "../../../images/Banner/jainism-outline3.svg";
// Shared with Royal Mahal: Shree Ganesh as a mask, so it takes this theme's colour
import GaneshMark from "../../../images/royal-mahal/ganesh.png";
import { ganeshChant, isJainInvite } from "../helpers";

/**
 * Shree Ganesh at the top of the card, or the Jain symbol for Jain invites, with its
 * chant below (as Royal Mahal's SacredMark). `showChant={false}` leaves the mark alone.
 */
const SacredMark = ({ religion, chant, className = "", showChant = true }) => {
  const jain = isJainInvite(religion);
  const src = jain ? JainSymbol : GaneshMark;
  return (
    <div className={`ut-sacred-mark ${className}`}>
      <span
        className={`ut-sacred ${jain ? "ut-sacred--jain" : "ut-sacred--ganesh"}`}
        role="img"
        aria-label={jain ? "Jain symbol" : "Shree Ganesh"}
        style={{ WebkitMaskImage: `url(${src})`, maskImage: `url(${src})` }}
      />
      {showChant && (
        <p className="ut-kicker ut-sacred-mark__chant">
          {jain ? "|| Shree Mahaveeray Namah ||" : chant}
        </p>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  religion: state.inviteDetails.invite?.religion,
  chant: ganeshChant(state.inviteDetails.invite),
});

export default connect(mapStateToProps)(SacredMark);
